import React from 'react';
import { useAuth } from '../context/AuthContext';
import './PendingApprovalScreen.css';

/**
 * PendingApprovalScreen Component
 * 
 * Shown to users who have registered but are awaiting admin approval
 */
const PendingApprovalScreen = () => {
  const { user, logout } = useAuth();

  return (
    <div className="pending-screen">
      <div className="pending-card">
        <div className="pending-icon">⏳</div>
        <h1>Wachtend op goedkeuring</h1>
        <p>
          Je account <strong>{user?.email}</strong> is aangemeld en wacht op goedkeuring door een beheerder.
        </p>
        <button className="logout-button" onClick={logout}>
          Uitloggen
        </button>
      </div>
    </div>
  );
};

export default PendingApprovalScreen;
